/**
 * Owner-editable site config (no feature code needs to change).
 *
 * DONATION_URL: set this to your Ko-fi / Buy Me a Coffee / GitHub Sponsors page to show a small
 * "Support" button on the main menu. Leave it empty ("") to hide the button entirely — that is
 * the default, so nothing dead-links until you have an account. (Owner action: create the
 * account, paste the URL here, redeploy.)
 */
export const DONATION_URL = "https://ko-fi.com/2skynix";
